import React from 'react';
import { Button, Box } from '@amzn/awsui-components-core';
import BrowserHistory from '../utils/BrowserHistory';
import RouterPaths from '../../common/RouterPaths';
import constants from '../../common/constants';

const HeaderDefaultActionMenus = () => {
  const openMyReview = () => {
    BrowserHistory.push(RouterPaths.MY_REVIEWS);
  };

  const openContentSuggestions = () => {
    BrowserHistory.push(RouterPaths.CONTENT_REQUESTS);
  };

  return (
    <>
      <Button variant="link" onClick={openMyReview}>
        {constants.AUTHOR_REVIEWS}
      </Button>
      <Button variant="link" onClick={openContentSuggestions}>
        {constants.GUIDANCE_BACKLOG}
      </Button>
    </>
  );
};

export default HeaderDefaultActionMenus;
